import { BasePaymentMethod } from '../BasePaymentMethod';
import { ImplementationType } from './types';
import { PaymentMethodType } from '../../enums/Tokens';
import { CreditCard } from '../credit-card/CreditCard';
import { ClientContext } from '../../core/ClientContext';
import { PaymentMethodConfig } from '../../models/ClientConfiguration';

const paymentMethodImplementationModules: Record<
  ImplementationType,
  () => Promise<{
    default: ({
      context,
      paymentMethodConfig,
    }: {
      context: ClientContext;
      paymentMethodConfig: PaymentMethodConfig;
    }) => void;
  }>
> = {
  [ImplementationType.WEB_REDIRECT]: () => import('./web-redirect'),
  [ImplementationType.NATIVE_SDK]: () => import('./native-sdk'),
};

const localPaymentMethodDefinitions: Record<
  string,
  { PaymentMethod: typeof BasePaymentMethod }
> = {
  [PaymentMethodType.PAYMENT_CARD]: {
    PaymentMethod: (CreditCard as unknown) as typeof BasePaymentMethod,
  },
};

const getPaymentMethod = async ({
  context,
  paymentMethodConfig,
}: {
  context: ClientContext;
  paymentMethodConfig: PaymentMethodConfig;
}) => {
  const { type, implementationType } = paymentMethodConfig;

  const localDefinition = localPaymentMethodDefinitions[type];

  if (localDefinition) {
    return localDefinition.PaymentMethod;
  }

  const paymentMethodImplementationModule =
    paymentMethodImplementationModules[implementationType];

  if (!paymentMethodImplementationModule) {
    return null;
  }

  const module = await paymentMethodImplementationModule();
  return module.default({ context, paymentMethodConfig });
};

export default getPaymentMethod;
